import Vue from 'vue'
import Router from 'vue-router'
import gztjjz from './gztjjz'
import yhpczl from './yhpczl'
import fxfjgk from './fxfjgk'
import jlysjz from './jlysjz'
import cxgjts from './cxgjts'
import xtgl from './xtgl'
import jcsjgl from './jcsjgl'
import zbpb from './zbpb'
import znxjjc from './znxjjc'
import aqjcb from './aqjcb'
import store from '@/store/index'
import zdwxy from './zdwxy'
import gykz from './gykz'
import zxjc from './zxjc'
import rydw from './rydw'

Vue.use(Router)
// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const router = new Router({
    routes: [{
        path: '/',
        name: 'Login',
        component: () =>
            import('@/components/Login/login')
    },
    {
        path: "/loaders",
        name: "loaders",
        component: () =>
            import("@/components/loaders/index.vue"),
        meta: {
            title: "加载中...",
            requireAuth: true,
            keepAlive: true,
            permission: true
        }
    },
    {
        path: '/Home',
        name: 'Home',
        component: () =>
            import('@/components/largescreen/leaderIndex.vue'),
        meta: { title: '首页', requireAuth: true, permission: true }
    },
    {
        path: 'renyuandingwei',
        name: 'renyuandingwei',
        // component: () =>import('@/components/leadership/personnelPositioning/index.vue'),
        meta: { title: '人员定位', requireAuth: true, permission: true }
    },
    {
        path: '/index',
        name: 'index',
        component: () =>
            import('@/components/leadership/personnelPositioning'),
        meta: { title: '领导驾驶舱', requireAuth: true, permission: true }
    },
    {
        path: '/HomePage',
        name: '',
        component: () =>
            import('@/components/HomePage/index'),
        meta: { title: '首页', requireAuth: true, permission: true },
        children: [{
            path: '',
            redirect: 'gztj_zzjg'
        },
        ...gztjjz,
        ...yhpczl,
        ...fxfjgk,
        ...jlysjz,
        ...cxgjts,
        ...xtgl,
        ...jcsjgl,
        ...zbpb,
        ...znxjjc,
        ...aqjcb,
        ...zdwxy,
        ...gykz,
        ...zxjc,
        ...rydw,
        {
            path: 'xxgl_receive',
            name: 'xxgl_receive',
            component: () =>
                import('@/components/xxgl/receive'),
            meta: { title: '接收消息', requireAuth: true, keepAlive: true, permission: true }
        },
        {
            path: 'tq',
            name: 'tq',
            component: () =>
                import('@/components/largescreen/tq'),
            meta: { title: '天气', requireAuth: true, keepAlive: true, permission: true }
        },
        {
            path: 'xxgl_save',
            name: 'xxgl_save',
            component: () =>
                import('@/components/xxgl/save'),
            meta: { title: '发送消息', requireAuth: true, keepAlive: true, permission: true }
        },
        {
            path: 'yandtszy',
            name: 'yandtszy',
            // component: () =>
            //                   import('@/components/tzzy/tzzy'),
            meta: { title: '特殊作业', requireAuth: true, keepAlive: true, permission: true }
        },
        // 安全检查表
        {
            path: 'vadio',
            name: 'vadio',
            component: () =>
                import('@/components/largescreen/vadio'),
            meta: { title: '视频', requireAuth: true, keepAlive: true, permission: true }
        },
        {
            path: 'sx',
            name: 'sx',
            component: () =>
                import('@/components/largescreen/ditu.vue'),
            meta: { title: '地图', requireAuth: true, keepAlive: true, permission: true }
        },
        {
            path: 'control',
            name: 'control',
            component: () =>
                import('@/components/accessControl/control.vue'),
            meta: { title: '门禁控制', requireAuth: true, keepAlive: true, permission: true }
        },
        {
            path: 'travelRecord',
            name: 'travelRecord',
            component: () =>
                import('@/components/accessControl/travelRecord.vue'),
            meta: { title: '通行记录', requireAuth: true, keepAlive: true, permission: true }
        },
        {
            path: 'statistics',
            name: 'statistics',
            component: () =>
                import('@/components/accessControl/statistics.vue'),
            meta: { title: '今日开门统计', requireAuth: true, keepAlive: true, permission: true }
        }
        ]
    }
    ]
})
export default router

router.beforeEach((to, from, next) => {
    // console.log(to.path)
    if (to.path === '/loaders') {
        let status = 'true'
        localStorage.setItem('loginstatus', status)
        // console.log('存储了loginStatus', JSON.parse(localStorage.getItem('loginstatus')))
        if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
            // console.log('查看loginstatus', localStorage.getItem('loginstatus'))
            if (JSON.parse(localStorage.getItem('loginstatus')) === true) { // 判断本地是否存在access_token
                // console.log('loaders-----loginStatus通过')
                if (to.meta.title) {
                    document.title = to.meta.title
                } else {
                    setTimeout(() => {
                        document.title = store.state.systemname
                    }, 500)
                }
                next()
            } else {
                next({
                    path: '/'
                })
            }
        } else {
            setTimeout(() => {
                document.title = store.state.systemname
            }, 500)
            next()
        }
    } else {
        if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
            // console.log('查看loginstatus', localStorage.getItem('loginstatus'))
            if (JSON.parse(localStorage.getItem('loginstatus')) === true) { // 判断本地是否存在access_token
                // console.log('null-loaders--loginStatus通过')
                if (to.meta.title) {
                    document.title = to.meta.title
                } else {
                    setTimeout(() => {
                        document.title = store.state.systemname
                    }, 500)
                }
                next()
            } else {
                next({
                    path: '/'
                })
            }
        } else {
            setTimeout(() => {
                document.title = store.state.systemname
            }, 500)
            next()
        }
    }
})


// WEBPACK FOOTER //
// ./src/router/index.js